import React from 'react';
import { Table, Button, Space, Tag } from 'antd';
import { PlusOutlined, EditOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { NubAccessLevelDTO } from '../types';

interface AccessLevelListProps {
    accessLevels: NubAccessLevelDTO[];
    onAccessLevelAction: (accessLevel: NubAccessLevelDTO | null, action: 'view' | 'add' | 'edit' | 'delete') => void;
}

export const AccessLevelList: React.FC<AccessLevelListProps> = ({
                                                                    accessLevels,
                                                                    onAccessLevelAction
                                                                }) => {
    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
            width: '15%',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            width: '30%',
        },
        {
            title: 'Permissions',
            key: 'permissions',
            width: '20%',
            render: (_: any, record: NubAccessLevelDTO) => (
                <Space size={[0, 4]} wrap>
                    {record.permissions?.slice(0, 3).map((permission) => (
                        <Tag key={permission.code} color="blue">
                            {permission.name}
                        </Tag>
                    ))}
                    {record.permissions && record.permissions.length > 3 && (
                        <Tag color="default">+{record.permissions.length - 3} more</Tag>
                    )}
                </Space>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            width: '15%',
            render: (_: any, record: NubAccessLevelDTO) => (
                <Space>
                    <Button
                        icon={<EyeOutlined />}
                        onClick={() => onAccessLevelAction(record, 'view')}
                    />
                    <Button
                        icon={<EditOutlined />}
                        onClick={() => onAccessLevelAction(record, 'edit')}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => onAccessLevelAction(record, 'delete')}
                    />
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div className="mb-4 flex justify-end">
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => onAccessLevelAction(null, 'add')}
                >
                    Add Access Level
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={accessLevels}
                rowKey="code"
            />
        </div>
    );
};